import jsPDF from "jspdf";

const G = [16, 185, 129]; // FitBersama green
const DARK = [17, 24, 39];
const GRAY = [107, 114, 128];

export function generateWeeklyPdf({ name, data, lang = "id", generatedAt = new Date() }) {
  const L = lang === "id"
    ? {
        title: "Laporan Mingguan", subtitle: "Ringkasan 7 hari terakhir", for: "Untuk",
        generated: "Dibuat", sessions: "Sesi Latihan", checkins: "Check-in", adherence: "Kepatuhan",
        volume: "Total Volume", sets: "Total Set", weightChange: "Perubahan Berat", prs: "Rekor Pribadi (PR)",
        none: "Belum ada PR minggu ini", footer: "Dibuat dengan FitBersama — teruslah bergerak, pantang menyerah!",
      }
    : {
        title: "Weekly Report", subtitle: "Summary of the last 7 days", for: "For",
        generated: "Generated", sessions: "Workout Sessions", checkins: "Check-ins", adherence: "Adherence",
        volume: "Total Volume", sets: "Total Sets", weightChange: "Weight Change", prs: "Personal Records (PRs)",
        none: "No PRs this week yet", footer: "Made with FitBersama — keep moving, never give up!",
      };

  const doc = new jsPDF({ unit: "pt", format: "a4" });
  const W = doc.internal.pageSize.getWidth();
  const M = 48;

  // Header band
  doc.setFillColor(...G);
  doc.rect(0, 0, W, 96, "F");
  doc.setTextColor(255, 255, 255);
  doc.setFont("helvetica", "bold");
  doc.setFontSize(26);
  doc.text("FitBersama", M, 46);
  doc.setFont("helvetica", "normal");
  doc.setFontSize(13);
  doc.text(L.title, M, 70);
  doc.setFontSize(10);
  doc.text(L.subtitle, M, 86);

  // Meta
  let y = 130;
  doc.setTextColor(...DARK);
  doc.setFont("helvetica", "bold");
  doc.setFontSize(16);
  doc.text(`${L.for}: ${name || "-"}`, M, y);
  doc.setFont("helvetica", "normal");
  doc.setTextColor(...GRAY);
  doc.setFontSize(10);
  const dstr = new Date(generatedAt).toLocaleDateString(lang === "id" ? "id-ID" : "en-US",
    { year: "numeric", month: "long", day: "numeric" });
  doc.text(`${L.generated}: ${dstr}`, M, y + 16);

  // Stat grid
  y += 48;
  const cards = [
    { label: L.sessions, value: String(data.sessions ?? 0) },
    { label: L.checkins, value: String(data.checkins ?? 0) },
    { label: L.adherence, value: `${data.adherence ?? 0}%` },
    { label: L.volume, value: `${(data.volume ?? 0).toLocaleString()} kg` },
    { label: L.sets, value: String(data.sets ?? 0) },
    {
      label: L.weightChange,
      value: data.weight_change != null ? `${data.weight_change > 0 ? "+" : ""}${data.weight_change} kg` : "—",
    },
  ];
  const cw = (W - M * 2 - 24) / 3;
  const ch = 78;
  cards.forEach((c, i) => {
    const col = i % 3;
    const row = Math.floor(i / 3);
    const x = M + col * (cw + 12);
    const cy = y + row * (ch + 12);
    doc.setDrawColor(229, 231, 235);
    doc.setFillColor(249, 250, 251);
    doc.roundedRect(x, cy, cw, ch, 8, 8, "FD");
    doc.setTextColor(...GRAY);
    doc.setFont("helvetica", "normal");
    doc.setFontSize(9);
    doc.text(c.label.toUpperCase(), x + 14, cy + 24);
    doc.setTextColor(...DARK);
    doc.setFont("helvetica", "bold");
    doc.setFontSize(22);
    doc.text(c.value, x + 14, cy + 54);
  });

  // PRs
  y += 2 * (ch + 12) + 24;
  doc.setTextColor(...DARK);
  doc.setFont("helvetica", "bold");
  doc.setFontSize(14);
  doc.text(L.prs, M, y);
  y += 22;
  doc.setFontSize(11);
  doc.setFont("helvetica", "normal");
  if (data.prs && data.prs.length) {
    data.prs.forEach((p) => {
      doc.setFillColor(...G);
      doc.circle(M + 4, y - 4, 3, "F");
      doc.setTextColor(...DARK);
      doc.text(String(p), M + 16, y);
      y += 20;
    });
  } else {
    doc.setTextColor(...GRAY);
    doc.text(L.none, M, y);
  }

  // Footer
  const H = doc.internal.pageSize.getHeight();
  doc.setDrawColor(...G);
  doc.setLineWidth(2);
  doc.line(M, H - 56, W - M, H - 56);
  doc.setTextColor(...GRAY);
  doc.setFontSize(9);
  doc.setFont("helvetica", "italic");
  doc.text(L.footer, M, H - 36);

  doc.save(`fitpulse-weekly-${new Date().toISOString().slice(0, 10)}.pdf`);
}
